export default __webpack_public_path__ + "static/media/Bandit's Mask of the Bloody Fang.cc86649a.jpg";